// pages/LoginPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAuth } from '../../src/Context/AuthContext';
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const LoginPage = ({ portalSettings }) => {
    //State Variables
    const { login, isAuthenticated } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Login`;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();

        const res = await fetch(`${apiURL}/account/login`, {
            method: 'POST',
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userName: username, password }),
        });

        if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            alert(errorData.message || 'Login failed.');
            return;
        }

        const data = await res.json();
        switch (data.result.resultType) {
            case 0:
                login();
                navigate('/home');
                break;
            case 17:
                navigate(`/twofactor?token=${encodeURIComponent(data.result.token)}`);
                break;
            default:
                alert('Unexpected response from server.');
                break;
        }
    };

    return (
        <div className="auth-page">
            <EmptyHeader />
            <EmptyHeader />
            <EmptyHeader />
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Login</h2>
                <form className="baseForm" onSubmit={handleLogin}>
                    <label className="baseLabel">Username</label>
                    <input className="baseInput" value={username} onChange={(e) => setUsername(e.target.value)} required />
                    <label className="baseLabel">Password</label>
                    <input className="baseInput" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <button className="baseButton" type="submit">Login</button>
                </form>
                <div className="auth-links">
                    <Link to="/forgotusername">Forgot Username?</Link>
                    <Link to="/forgotpassword">Forgot Password?</Link>
                    <Link to="/register">Register</Link>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
